<template ref="wrapRef">
  <div>
    <a-config-provider
      :locale="zhCN"
      :theme="{
        token: theme,
      }"
    >
      <RouterView />
    </a-config-provider>
  </div>
</template>
<script setup lang="ts">
import zhCN from "ant-design-vue/es/locale/zh_CN";
import { useStore } from "./store";
import { watermark } from "@/tools";
import { Cache } from "./tools/cache";
import * as ENUM from "@/enum";

const { dispatch, getState } = useStore();

const theme = computed(() => ENUM.COMMON.Theme[getState().sTheme]);

/**
 * 功能：应用初始化
 */
const appInit = async () => {
  const loginInfo = Cache.LOGIN_INFO.getItem();

  dispatch({
    type: "common/getTheme",
  });

  try {
    await dispatch({
      type: "login/loginInfo",
      payload: loginInfo,
    });

    if (loginInfo) {
      await dispatch({ type: "tab/getList" });
      const d = await dispatch({ type: "tab/getActive" });
      dispatch({ type: "favorite/getList" });
    }
  } catch (error) {
    console.log(error);
  }
};

watch(
  () => getState().sUserInfo?.user,
  (val) => {
    const orgList = getState().sUserInfo?.userOrganizationList || [];
    watermark.draw(
      `${val?.userName || ""} ${orgList[orgList?.length - 1]?.orgName || ""}`,
      "off"
    );
  },
  { deep: true }
);

onMounted(() => {
  appInit();
});

onBeforeUnmount(() => {
  watermark.destroy();
});
</script>

<style lang="scss" scoped></style>
